

export const getServerName = () => {

    const devServerHostList = ['localhost'];
    const testServerHostList = ['testup.mit4mit.co.il'];
    const liveServerHostList = ['planup.co.il','www.planup.co.il'];

    if (devServerHostList.includes(window.location.hostname))
        return 'DevUp';


    if (testServerHostList.includes(window.location.hostname))
        return 'TestUp';


    if (liveServerHostList.includes(window.location.hostname))
        return 'PlanUp';
    
}


//the browser tab's title: the server name, and after " :: " the name of what the page edits
//(עריכת משתמש / עריכת אירוע). The router sets the bare title again on every URL change, so a
//page's suffix never outlives the page.
export const getPageTitle = (suffix) => (getServerName() || 'PlanUp') + (suffix ? ' :: ' + suffix : '');


export const getServerSettings = () => {

    switch (getServerName()){

        case 'DevUp':

            return {
                APP_URL: "http://localhost:8080/",
                API_V2_URL: "http://localhost:2053/apiv2/",
                MEDIA_URL: "http://localhost/public/",
                SIGN_DOCUMENT_URL : "http://localhost/signDocument.php",
                SIGN_CUSTOM_DOCUMENT_URL : "http://localhost/signCustomDocument.php",
                SHOW_DOCUMENT_URL : "http://localhost/showDocument.php",
                CREATE_PDF_URL : "http://localhost/createPdf.php",
                CREATE_MENU_PDF_URL : "http://localhost/createMenuPdf.php",
                SOCKET_URL: `http://localhost:4000/`,
                NEW_CONTACT_FORM:'http://localhost/forms/contact.php?tenantId=',
                CONTACT_FORM_SHORT:'http://localhost/forms/contact.php?c=',
                BOOKING_FORM:'http://localhost:8890/booking.php?c=',
                PRODUCTION_FORM:'http://localhost:8891/production-form.php?c='

            };

        case 'PlanUp':

        return {
            APP_URL: "https://planup.co.il/",
            API_V2_URL: window._apiUrl ? window._apiUrl : "https://planup.co.il/apiv2/",
            SOCKET_URL: `https://planup.co.il:4000/`,
            MEDIA_URL: "https://www.planup.co.il/not-in-use",
            SIGN_DOCUMENT_URL : "https://planup.co.il/sign/",
            SIGN_CUSTOM_DOCUMENT_URL : "https://planup.co.il/signdoc/",
            SHOW_DOCUMENT_URL : "https://planup.co.il/doc/",
            CREATE_PDF_URL : "https://planup.co.il/p2/docs/createPdf.php",
            CREATE_MENU_PDF_URL : "https://planup.co.il/p2/docs/createMenuPdf.php",
            NEW_CONTACT_FORM:'https://planup.co.il/p2/contact.php?tenantId=',
            CONTACT_FORM_SHORT:'https://planup.co.il/c/',
            BOOKING_FORM:'https://planup.co.il/b/',
            PRODUCTION_FORM:'https://planup.co.il/f/',
            SHORT_DOC_LINK_BASE:'https://planup.co.il/d/'
        };


    }

}


export const useMultiSchemaTenancy = () => {

    return true;
}

export const isPlanup = () => {

    return true;
}



class Config {
    
    static hostname = isPlanup() ? 'planup.co.il' : 'seatup.co.il';

    static SETTINGS = getServerSettings();

    // Public booking short link — tenantId encoded as base36 keeps shared URLs compact
    // (prod /b/<code> is rewritten by nginx to /booking.php?c=<code>).
    // An optional invite code (<contact36>-<sig>, from GET booking/invite-code) personalises the
    // link so the public form opens pre-filled with that contact's details. It is appended to the
    // code itself rather than as a query arg — the nginx rewrite drops the original query string.
    // A crewMemberId points the link at that crew member's own booking calendar
    // (/b/<tenant36>-c<crew36>); without one it is the business's main calendar.
    static bookingLink(tenantId, inviteCode, crewMemberId) {
        return Config.SETTINGS.BOOKING_FORM + Number(tenantId).toString(36)
            + (crewMemberId ? '-c' + Number(crewMemberId).toString(36) : '')
            + (inviteCode ? '-' + inviteCode : '');
    }

    // טופס הפקה — the couple's public link to one event's production form. The code comes from
    // the API (GET production-form/event/:id → link.code): <tenant36>-<form36>-<token>, the token a
    // per-form secret the business can regenerate to void links already sent.
    // (prod /f/<code> is rewritten by nginx to /production-form.php?c=<code>.)
    static productionFormLink(code) {
        return Config.SETTINGS.PRODUCTION_FORM + code;
    }

    // Public new-lead contact form short link — same base36 scheme
    // (prod /c/<code> is rewritten by nginx to /contact.php?c=<code>).
    // Legacy NEW_CONTACT_FORM (?tenantId=) links already sent to customers stay valid.
    static contactLink(tenantId) {
        return Config.SETTINGS.CONTACT_FORM_SHORT + Number(tenantId).toString(36);
    }

    // Public tax-document short link — /d/<base36 tenant>-<base36 doc>-<secret>
    // (prod /d/<code> is rewritten by nginx to /docs/showDocument.php?d=<code>).
    // The secret is the two trailing random hex runs of the document's stored
    // hashForSignatureLink, so the server verifies it against the row without a
    // new column, and every already-issued document has a short link for free.
    // Long /doc/?i= links already sent to customers stay valid.
    static docLink(taxDocument) {

        let hash = taxDocument.hashForSignatureLink;

        if (!hash)
            return null;

        let longLink = Config.SETTINGS.SHOW_DOCUMENT_URL + '?i=' + hash;

        if (!Config.SETTINGS.SHORT_DOC_LINK_BASE)
            return longLink;

        try {
            let decoded = atob(hash);
            let tenantId = parseInt(decoded.substr(6, 13), 10);
            let docId = parseInt(decoded.substr(25, 7), 10);
            let secret = decoded.substr(19, 6) + decoded.substr(32, 6);

            if (tenantId && docId && /^[0-9a-f]{12}$/.test(secret))
                return Config.SETTINGS.SHORT_DOC_LINK_BASE + tenantId.toString(36) + '-' + docId.toString(36) + '-' + secret;
        } catch (e) { }

        return longLink;
    }

    static API_ROUTES = {
        'login': 'login',
        'isLogged': 'isLogged',
        'dashboard': 'dashboard',
        'users': 'users',
        'appointments': 'appointments',
        'quotations': 'quotations',
        'contact': 'contact',
        'events': 'events',
        'guests': 'guests',
        'upload': 'fileUpload',
        'halls': 'halls',
        'tables': 'tables',
        'reports': 'reports',
        'presets': 'presets',
        'settings': 'appSettings',
        'calendar': 'calendar',
        'equipments': 'equipment',
        'banners': 'banners'
    }
    
    static DEFAULT_API_SETTINGS = { headers: { 'Content-Type': 'text/json' }, withCredentials: true };

    static DEFAULT_API_V2_SETTINGS() {
        return {
            baseURL: Config.SETTINGS.API_V2_URL,
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }
    static GUEST_STATUS = {
        'notResponded': 0,
        'coming': 1,
        'maybe': 2,
        'notComing': 3,
    }

    static html2CanvasConfig = {
        "type": "dataURL",
        // "allowTaint": true,
        // "foreignObjectRendering": false,
        // "logging": false,
        "useCORS": true,
        // "crossOrigin": 'anonymous'
    }

};

export default Config
